import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { ICarePlanMedicalNotesModel } from './types';

const carePlanMedicalNotes: ICarePlanMedicalNotesModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default carePlanMedicalNotes;
